import { render, staticRenderFns } from "./auto-renew-block2.vue?vue&type=template&id=197dba19&scoped=true&lang=pug&"
import script from "./auto-renew-block2.vue?vue&type=script&lang=js&"
export * from "./auto-renew-block2.vue?vue&type=script&lang=js&"
import style0 from "./auto-renew-block2.vue?vue&type=style&index=0&id=197dba19&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197dba19",
  null
  
)

export default component.exports